import { useState, useEffect } from 'react'
import { API_URL } from '../config/api'
import './Team.css'

function Team() {
  const [members, setMembers] = useState([])
  const [loading, setLoading] = useState(true)
  const [expandedId, setExpandedId] = useState(null)

  const getDescriptionText = (desc) => {
    if (typeof desc === 'string') return desc
    if (Array.isArray(desc)) {
      return desc
        .map(block => block.children?.map(child => child.text).join('') || '')
        .join('\n')
    }
    return ''
  }

  // Optimized image URL resolver using Strapi formats
  const getImageUrl = (image, preferredSize = 'medium') => {
    if (!image) return null
    const attrs = Array.isArray(image.data) ? image.data[0]?.attributes : image.data?.attributes
    if (!attrs) return image.url || null

    const formats = attrs.formats
    if (formats) {
      if (preferredSize === 'small' && formats.small?.url) return formats.small.url
      if (preferredSize === 'medium' && formats.medium?.url) return formats.medium.url
      if (preferredSize === 'large' && formats.large?.url) return formats.large.url
    }
    return attrs.url || image.url
  }

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        // Optimized Strapi query: Fetch only required fields and image variants
        const response = await fetch(
          `${API_URL}/api/team-members?sort=order:asc&populate[image][fields][0]=url&populate[image][fields][1]=formats&fields[0]=name&fields[1]=role`
        )
        const data = await response.json()
        const membersData = (data.data || [])
          .map(item => ({
            id: item.id,
            ...item.attributes
          }))
        setMembers(membersData)
      } catch (error) {
        console.error('Error fetching team members:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchTeamMembers()
  }, [])

  return (
    <section className="team">
      <h2>Ontmoet Ons Team</h2>
      <p className="team-subtitle">Gepassioneerde professionals die zich inzetten voor excellentie</p>

      {loading ? (
        <div className="loading">Teamleden worden geladen...</div>
      ) : members.length === 0 ? (
        <div className="no-members">
          <p>Nog geen teamleden beschikbaar.</p>
        </div>
      ) : (
        <div className="team-grid">
          {members.map((member, index) => (
            <div
              key={member.id}
              className={`team-card ${expandedId === member.id ? 'expanded' : ''}`}
              onClick={() => setExpandedId(expandedId === member.id ? null : member.id)}
            >
              {member.image && getImageUrl(member.image, 'medium') && (
                <div className="member-image-container">
                  <img
                    src={`${API_URL}${getImageUrl(member.image, 'medium')}`}
                    alt={member.name}
                    className="member-image"
                    loading={index < 4 ? 'eager' : 'lazy'}
                    decoding="async"
                  />
                </div>
              )}
              <div className="member-content">
                <div className="member-info">
                  <h3>{member.name}</h3>
                  <p className="member-role">{member.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}

export default Team